// import external dependencies
import 'jquery';

// Import everything from autoload
//

// Import components
import './components/homepage_lightbox';
import './components/desktop_nav_search';
import './components/expand';
import './components/key_campaigns_carousel';
import './components/home_mobile_leftnav';
import './components/quote_rotator';
import './components/resources';
import './components/skip_to_content';
import './components/accordion';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js